const _CHART_OBJECT = {
  home: {
    p: 0,
    v: ''
  },
  away: {
    p: 0,
    v: ''
  },
  visible: false
};

const _COMPARISON_CHART_INIT = {
  fieldGoalsPercentage: { ..._CHART_OBJECT, name: '야투 성공율', key: 3 },
  threePointFieldGoalsPercentage: {
    ..._CHART_OBJECT,
    name: '3점슛 성공율',
    key: 4
  },
  freeThrowsPercentage: { ..._CHART_OBJECT, name: '자유투 성공율', key: 5 },
  assists: { ..._CHART_OBJECT, name: '어시스트', key: 6 },
  reboundsTotal: { ..._CHART_OBJECT, name: '리바운드', key: 7 },
  steals: { ..._CHART_OBJECT, name: '스틸', key: 8 },
  blockedShots: { ..._CHART_OBJECT, name: '블록', key: 9 },
  turnoversTotal: { ..._CHART_OBJECT, name: '턴오버', key: 10 }
};

export { _COMPARISON_CHART_INIT };
